"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "name": "@okta/okta-react",
  "version": "1.1.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/okta-react/dist/packageInfo.js
// module id = 619
// module chunks = 2